import React from 'react';
import { Skeleton } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import OrderCard from './OrderCard';
import { EmptyState, EmptyStateIcon, EmptyStateText, OrderCardSkeleton } from './styles';
import type { OrderTableProps } from './types';

const SKELETON_CARD_COUNT = 2;

const OrderTable: React.FC<OrderTableProps> = ({
  orders,
  loading,
  expandedOrderId,
  onToggleExpand,
  searchTerm,
  statusFilter,
  tabName,
}) => {
  if (loading) {
    return (
      <>
        {Array.from({ length: SKELETON_CARD_COUNT }).map((_, index) => (
          <OrderCardSkeleton key={`skeleton-${index}`}>
            <Skeleton active paragraph={{ rows: 4 }} />
          </OrderCardSkeleton>
        ))}
      </>
    );
  }

  if (orders.length === 0) {
    return (
      <EmptyState>
        <EmptyStateIcon>
          <FontAwesomeIcon icon={faShoppingBag} />
        </EmptyStateIcon>
        <EmptyStateText>No {tabName} orders found</EmptyStateText>
        <EmptyStateText>
          {searchTerm || statusFilter !== 'all'
            ? 'Try adjusting your search or filters'
            : 'Orders will appear here when customers place them'}
        </EmptyStateText>
      </EmptyState>
    );
  }

  return (
    <>
      {orders.map((order) => (
        <OrderCard
          key={order?.id}
          order={order}
          isExpanded={expandedOrderId === String(order?.id)}
          onToggleExpand={() => onToggleExpand(String(order?.id))}
        />
      ))}
    </>
  );
};

export default OrderTable;
